import { msg } from '@lingui/core/macro'
import { createFileRoute } from '@tanstack/react-router'
import { VisitDetail } from '~/components/visits/visit-detail'
import { titleFor } from '~/lib/route-title'
import type { Id } from '~convex/_generated/dataModel'

/**
 * The visit report lives under its project in the URL — a visit only ever
 * means something in the context of one obra — but NOT inside the project
 * route's component. The trailing `_` on `$projectId_` is TanStack's
 * non-nested escape: the path keeps the project segment while the page
 * renders on its own, instead of inside the project detail's tab strip.
 */
export const Route = createFileRoute(
  '/_authenticated/$workspaceSlug/projects/$projectId_/visits/$visitId'
)({
  component: VisitDetailRoute,
  head: () => ({ meta: [{ title: titleFor(msg`Visit`) }] }),
})

function VisitDetailRoute() {
  const { visitId } = Route.useParams()

  return <VisitDetail id={visitId as Id<'siteVisits'>} key={visitId} />
}
